<template>
  <v-app id="inspire">
    <div class="mb-16">
      <v-container>
        <v-toolbar>
          <v-app-bar-nav-icon>
            <v-img src="assets/img/logo.png" max-width="80" />
          </v-app-bar-nav-icon>
          <v-toolbar-title class="company">
            <a href="https://www.agendadigitale.biella.it/dmi" target="_blank">Database Multimediale Infinito</a>
          </v-toolbar-title>
          <template>
            <v-spacer />
            <v-btn href="https://docs.google.com/forms/d/e/1FAIpQLSfrzrrfVxVgFxYpaUorxwvIcuUJcsZojzKqgNVyELaUCnYjtg/viewform" target="_blank">
              Carica la tua foto
            </v-btn>
          </template>
        </v-toolbar>

        <v-row class="mt-4">
          <v-col cols="12" md="3" sm="12" order="1" order-md="1" class="pt-0">
            <v-card outlined dense class="filters-column">
              <v-select dense class="pa-3" :items="ordItems" hint="Criterio ordinamento" v-model="ordCriteria" persistent-hint />
              <v-switch v-model="ordMode" inset :color="color" :label="getOrdMode" v-if="ordCriteria !== 'Casuale'" class="pl-3"></v-switch>
              <v-select
                dense
                class="pa-3 d-none d-lg-block"
                :items="numImages.items"
                item-text="text"
                item-value="value"
                hint="Visualizzazione immagini per riga"
                v-model="numImages.cnt"
                persistent-hint
              />

              <v-divider></v-divider>

              <v-btn depressed color="primary" class="ml-2 mb-2 mt-4" @click="removeFilter">Rimuovi filtri</v-btn>

              <v-expansion-panels multiple accordion v-model="panel">
                <v-expansion-panel>
                  <v-expansion-panel-header>
                    Filtri
                    <v-chip v-if="showActiveFiltersBadge[0]" class="ma-2" :color="color" dense>Filtri attivi</v-chip>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-select dense class="pa-3" :items="licenza.items" :hint="licenza.trad" v-model="licenza.filter" persistent-hint />
                    <v-select dense class="pa-3" :items="zonaBiellese.items" :hint="zonaBiellese.trad" v-model="zonaBiellese.filter" persistent-hint />
                    <v-autocomplete dense class="pa-3" :items="comuni.items" :hint="comuni.trad" v-model="comuni.filter" persistent-hint />
                    <v-select
                      dense
                      class="pa-3"
                      :items="luogoCaratteristico.items"
                      :hint="luogoCaratteristico.trad"
                      v-model="luogoCaratteristico.filter"
                      persistent-hint
                    />
                  </v-expansion-panel-content>
                </v-expansion-panel>
                <v-expansion-panel v-model="panelIndex">
                  <v-expansion-panel-header>
                    Filtri avanzati
                    <v-chip v-if="showActiveFiltersBadge[1]" class="ma-2" :color="color" dense>Filtri attivi</v-chip>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-autocomplete dense class="pa-3" :items="fotografo.items" :hint="fotografo.trad" v-model="fotografo.filter" persistent-hint />
                    <div class="v-input pa-3">
                      <v-btn v-on:click="showDatePicker = true" v-if="!showDatePicker" style="width: 100%; font-size: 11px">
                        <v-icon>mdi-calendar</v-icon>
                        Data Caricamento
                      </v-btn>
                      <v-btn v-on:click="showDatePicker = false" v-if="showDatePicker" style="width: 100%; font-size: 11px">
                        <v-icon>mdi-calendar</v-icon>
                        Nascondi
                      </v-btn>
                    </div>
                    <div class="v-input pa-3">
                      <v-date-picker
                        v-model="dates"
                        locale="it-it"
                        first-day-of-week="1"
                        range
                        v-if="showDatePicker"
                        style="width: 100%"
                        color="pink accent-2"
                        elevation="4"
                      ></v-date-picker>
                    </div>

                    <v-select dense class="pa-3" :items="club.items" :hint="club.trad" v-model="club.filter" persistent-hint />
                    <v-select dense class="pa-3" :items="sezionale.items" :hint="sezionale.trad" v-model="sezionale.filter" persistent-hint />
                    <v-select
                      dense
                      class="pa-3"
                      :items="pubbl.items"
                      item-text="text"
                      item-value="value"
                      :hint="pubbl.trad"
                      v-model="pubbl.filter"
                      persistent-hint
                    />
                    <v-select dense class="pa-3" :items="elemImg.items" :hint="elemImg.trad" v-model="elemImg.filter" multiple persistent-hint />
                    <v-select dense class="pa-3" :items="layout.items" :hint="layout.trad" v-model="layout.filter" persistent-hint />

                    <v-range-slider
                      :hint="mp.trad"
                      :color="color"
                      :min="mp.interval[0]"
                      :max="mp.interval[1]"
                      step="10"
                      v-model="mp.values"
                      persistent-hint
                      class="px-3 pt-3"
                    />
                    <div class="px-3 pb-3">{{ mp.values[0] }} - {{ mp.values[1] }}</div>
                    <v-range-slider
                      :hint="w.trad"
                      :color="color"
                      :min="w.interval[0]"
                      :max="w.interval[1]"
                      step="100"
                      v-model="w.values"
                      persistent-hint
                      class="px-3 pt-3"
                    />
                    <div class="px-3 pb-3">{{ w.values[0] }} - {{ w.values[1] }}</div>
                    <v-range-slider
                      :hint="h.trad"
                      :color="color"
                      :min="h.interval[0]"
                      :max="h.interval[1]"
                      step="100"
                      v-model="h.values"
                      persistent-hint
                      class="px-3 pt-3"
                    />
                    <div class="px-3 pb-3">{{ h.values[0] }} - {{ h.values[1] }}</div>
                    <v-range-slider
                      :hint="size.trad"
                      :color="color"
                      :min="size.interval[0]"
                      :max="size.interval[1]"
                      step="1"
                      v-model="size.values"
                      persistent-hint
                      class="px-3 pt-3"
                    />
                    <div class="px-3 pb-3">{{ size.values[0] }} - {{ size.values[1] }}</div>
                    <v-range-slider
                      :hint="dpi.trad"
                      :color="color"
                      :min="dpi.interval[0]"
                      :max="dpi.interval[1]"
                      step="10"
                      v-model="dpi.values"
                      persistent-hint
                      class="px-3 pt-3"
                    />
                    <div class="px-3 pb-3">{{ dpi.values[0] }} - {{ dpi.values[1] }}</div>
                    <v-range-slider
                      :hint="rating.trad"
                      :color="color"
                      :min="rating.interval[0]"
                      :max="rating.interval[1]"
                      step="5"
                      v-model="rating.values"
                      persistent-hint
                      class="px-3 pt-3"
                    />
                    <div class="px-3 pb-3">{{ rating.values[0] }} - {{ rating.values[1] }}</div>
                    <v-select dense class="pa-3" :items="contesto.items" :hint="contesto.trad" v-model="contesto.filter" persistent-hint />
                    <v-select dense class="pa-3" :items="tecnica.items" :hint="tecnica.trad" v-model="tecnica.filter" persistent-hint />
                    <v-select dense class="pa-3" :items="creativita.items" :hint="creativita.trad" v-model="creativita.filter" persistent-hint />
                    <v-select dense class="pa-3" :items="pPubblico.items" :hint="pPubblico.trad" v-model="pPubblico.filter" persistent-hint />
                    <v-select dense class="pa-3" :items="pCritica.items" :hint="pCritica.trad" v-model="pCritica.filter" persistent-hint />
                    <v-select dense class="pa-3" :items="pUsabilita.items" :hint="pUsabilita.trad" v-model="pUsabilita.filter" persistent-hint />
                    <v-select dense class="pa-3" :items="persone.items" :hint="persone.trad" v-model="persone.filter" persistent-hint />
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </v-card>
          </v-col>
          <v-col cols="12" md="9" sm="12" order="2" order-md="2">
            <v-row dense>
              <v-col cols="6">
                <small>{{ this.filteredRows.length }} di {{ this.rows.length }} immagini</small>
              </v-col>
              <v-col cols="6" class="text-right">
                <small>Data aggiornamento: {{ this.updateDate }}</small>
              </v-col>
              <v-col :key="row.id" v-for="row in filteredRows" :class="`mb-3 col-12 col-md-4 col-lg-${12 / numImages.cnt}`">
                <v-lazy class="h-100">
                  <v-card class="mx-auto photo-card h-100">
                    <a :href="`https://drive.google.com/open?id=${row.idOggetto}`" target="_blank" class="img-link">
                      <v-img class="white--text align-end" height="200px" :src="`${host}/img/preview/${row.id}.jpg`">
                        <v-card-title v-if="numImages.cnt <= 4" style="font-size: 0.8em" class="pb-0">
                          {{ row.titolo.length > 22 ? `${row.titolo.substring(0, 22)}..` : row.titolo }}
                        </v-card-title>
                      </v-img>
                      <v-progress-circular v-if="row.rating" :rotate="360" :size="30" :width="4" :value="row.rating" :color="color" style="font-size: 12px">
                        {{ row.rating }}
                      </v-progress-circular>

                      <div v-if="row.licenza == 'Diritto di autore'" class="light-blue accent-4 white--text premium-tag">PRIME</div>
                    </a>

                    <div class="mt-auto">
                      <v-card-subtitle class="pb-0 pt-0 mb-6 d-flex">
                        <div class="photo-owner" style="flex-grow: 1; line-height: 16px; vertical-align: middle">
                          {{ row.nomeCognome == '' ? '-' : row.nomeCognome }}
                        </div>
                        <v-btn v-if="row.ig" icon x-small dense class="white--text igbg px-1" :href="`https://instagram.com/${row.ig}`" target="_blank">
                          <v-icon>mdi-instagram</v-icon>
                        </v-btn>
                      </v-card-subtitle>

                      <v-card-actions :class="`px-0 py-0 mt-3 ${color}`">
                        <v-btn text class="white--text" width="100%" @click="openDetails(row.id)">Dettagli</v-btn>
                      </v-card-actions>
                    </div>
                  </v-card>
                </v-lazy>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-container>
    </div>
    <v-footer class="grey darken-4">
      <v-container>
        <div style="padding: 4px 16px">
          <v-row>
            <v-col cols="2" class="text-left">
              <v-btn href="https://docs.google.com/document/d/1GlaLoRdE8scjvOL_tBWZG-P0XUvFRAkItY1VN6Rwddg" outlined target="_blank" class="white--text">
                Regolamento
              </v-btn>
            </v-col>
            <v-col cols="4" class="text-left">
              <a
                href="https://app.legalblink.it/api/documents/66f558e3c01176001adfb60a/privacy-policy-per-siti-
web-o-e-commerce-it"
                target="https://app.legalblink.it/api/documents/66f558e3c01176001adfb60a/privacy-policy-per-siti-
web-o-e-commerce-it"
                class="white--text"
              >
                Privacy policy
                <v-icon class="white--text">mdi-open-in-new</v-icon>
              </a>
              <br />
              <a
                href="https://app.legalblink.it/api/documents/66f558e3c01176001adfb60a/cookie-policy-it"
                target="https://app.legalblink.it/api/documents/66f558e3c01176001adfb60a/cookie-policy-it"
                class="white--text"
              >
                Cookie policy
                <v-icon class="white--text">mdi-open-in-new</v-icon>
              </a>
            </v-col>
            <v-col cols="6" class="text-right">
              <a href="https://www.3-w.it/" target="_blank">
                <v-img src="assets/img/logo3W.png" width="130" style="display: inline-block; margin: 0 !important" />
              </a>
            </v-col>
          </v-row>
        </div>
      </v-container>
    </v-footer>
  </v-app>
</template>

<style>
  a {
    text-decoration: none;
  }

  .h-100 {
    height: 100%;
  }

  .company {
    font-family: 'Oswald' !important;
    font-weight: 400;
    font-size: 16pt;
    display: none;
  }
  @media (min-width: 620px) {
    .company {
      display: block;
    }
  }
  .v-application--is-ltr .v-toolbar__content > .v-btn.v-btn--icon:first-child,
  .v-application--is-ltr .v-toolbar__extension > .v-btn.v-btn--icon:first-child {
    margin-left: 16px;
    margin-right: 16px;
  }

  button.v-expansion-panel-header {
    padding-right: 12px;
    padding-left: 12px;
  }
  .v-expansion-panel-content__wrap {
    padding: 0;
  }

  .photo-card {
    display: flex;
    flex-direction: column;
    overflow: hidden;
  }

  @media (min-width: 960px) {
    .filters-column {
      position: sticky;
      top: 24px;
      max-height: calc(100vh - 180px);
      overflow: auto;
    }
  }

  .photo-card .img-link {
    text-decoration: none;
    display: block;
    position: relative;
  }
  .photo-card .img-link .premium-tag {
    right: -38px;
    top: 16px;
    position: absolute;
    padding: 5px 50px;
    transform: rotate(45deg);
    font-size: 12px;
    transform-origin: center;
  }
  .photo-card .img-link .v-progress-circular {
    position: absolute;
    right: 4px;
    bottom: 4px;
    background-color: #fff;
    border-radius: 20px;
  }
  .photo-card .v-card__subtitle {
    margin-top: 24px;
    position: relative;
    align-items: end;
  }

  .igbg {
    font-size: 12px;
    min-width: 0;
    background: #d6249f;
    background: radial-gradient(circle at 30% 107%, #fdf497 0%, #fdf497 5%, #fd5949 45%, #d6249f 60%, #285aeb 90%);
  }

  span.ma-2.v-chip.theme--light.v-size--default.orange.accent-4 {
    float: right;
    flex: 0 1 auto;
    margin-left: auto !important;
    display: inline-flex;
  }
  .v-application--is-ltr .v-expansion-panel-header__icon {
    margin-left: 0;
  }
  button.v-expansion-panel-header {
    justify-content: flex-end;
  }
  .v-expansion-panel--active > .v-expansion-panel-header {
    justify-content: space-between;
  }
  .v-date-picker-title__date {
    font-size: 14px !important;
  }
  .v-date-picker-header {
    padding: 4px !important;
  }
  .v-picker__body {
    width: 100% !important;
  }
  .v-date-picker-header__value button {
    padding: 0 !important;
    font-size: 11px !important;
  }
  .v-date-picker-table {
    padding: 0 4px !important;
  }

  .v-date-picker-table table {
    width: 100% !important;
    display: block !important;
  }
  .v-date-picker-table table thead,
  .v-date-picker-table table tbody {
    width: 100% !important;
    display: block !important;
  }
  .v-date-picker-table table tr {
    display: flex !important;
    justify-content: space-between !important;
    width: 100% !important;
  }
  .v-date-picker-table table tr th,
  .v-date-picker-table table tr td {
    width: 14.28571429% !important;
    display: block !important;
    flex: 1 1 auto !important;
    max-width: 40px;
  }
  .v-date-picker-table .v-btn {
    z-index: auto !important;
    margin: 0 !important;
    font-size: 12px !important;
    border-radius: 4px !important;
    height: 24px !important;
    width: 100% !important;
    display: block !important;
    text-align: right !important;
  }

  footer.v-footer {
    position: fixed !important;
    bottom: 0;
    left: 0;
    width: 100%;
    z-index: 1;
  }
  footer.v-footer .v-image {
    margin: 0 auto !important;
  }

  .v-application .primary {
    background-color: #2d3753 !important;
    border-color: #2d3753 !important;
  }
</style>
<script>
  import axios from 'axios';
  import '@fontsource/oswald';
  import dayjs from 'dayjs';
  import utc from 'dayjs/plugin/utc';
  dayjs.extend(utc);
  import customParseFormat from 'dayjs/plugin/customParseFormat';
  dayjs.extend(customParseFormat);

  export default {
    data() {
      let other = 'Altro..';
      return {
        showDatePicker: false,
        updateDate: '',
        showActiveFiltersBadge: [false, false],
        panelIndex: -1,
        color: 'coen',
        numImages: {
          cnt: 4,
          items: [
            { text: '3', value: 3 },
            { text: '4', value: 4 },
            { text: '6', value: 6 },
          ],
        },
        ordMode: true,
        ordItems: ['Autore', 'Casuale', 'Data upload', 'Rating', 'Titolo'],
        ordCriteria: 'Data upload',
        host: 'https://d11dbyh69xtpdi.cloudfront.net',
        otherPlaceholder: other,
        filteredRows: [],
        rows: [],
        dates: [],
        rating: {
          trad: 'Rating globale (%)',
          values: [0, 100],
          interval: [0, 100],
        },
        mp: {
          trad: 'Megapixel (larghezza x altezza)',
          values: [0, 100],
          interval: [0, 100],
        },
        w: {
          trad: 'Larghezza (pixel)',
          values: [0, 100],
          interval: [0, 100],
        },
        h: {
          trad: 'Altezza (pixel)',
          values: [0, 100],
          interval: [0, 100],
        },
        size: {
          trad: 'Peso (MByte)',
          values: [0, 100],
          interval: [0, 100],
        },
        dpi: {
          trad: 'Risoluzione (DPI)',
          values: [0, 100],
          interval: [0, 100],
        },
        creativita: {
          trad: 'Creatività',
          items: ['', '1', '2', '3', '4'],
          filter: '',
        },
        contesto: {
          trad: 'Contesto',
          items: ['', '1', '2', '3', '4'],
          filter: '',
        },
        tecnica: {
          trad: 'Tecnica',
          items: ['', '1', '2', '3', '4'],
          filter: '',
        },
        pubbl: {
          trad: 'Pubblicato',
          items: [
            { value: '', text: '' },
            { value: '-', text: 'Mai pubblicato' },
            { value: 'facebook', text: 'Social' },
            { value: 'eco', text: 'Eco di Biella' },
          ],
          filter: '',
        },
        pPubblico: {
          trad: 'Premio Pubblico',
          items: ['', 'sì', 'no'],
          filter: '',
        },
        pCritica: {
          trad: 'Premio Critica',
          items: ['', 'sì', 'no'],
          filter: '',
        },
        pUsabilita: {
          trad: 'Premio Usabilità',
          items: ['', 'sì', 'no'],
          filter: '',
        },
        persone: {
          trad: 'Persone in foto',
          items: ['', 'sì', 'no'],
          filter: '',
        },
        licenza: {
          trad: 'Licenza',
          items: ['', 'Creative Commons 3.0', 'Diritto di autore'],
          filter: '',
        },
        comuni: {
          trad: 'Territorio Comunale',
          items: [''],
          filter: '',
        },
        fotografo: {
          trad: 'Fotografo',
          items: ['', 'Anonimo'],
          filter: '',
        },
        zonaBiellese: {
          trad: 'Zona del Biellese',
          items: [
            '',
            'Valle Cervo',
            'Valle Elvo',
            'Valle Oropa',
            'Valle Mosso',
            'Val Sessera',
            'Crinale tra le valli',
            'Serra',
            'Lago di Viverone',
            'Bessa',
            'Baraggia',
            'Biella Centro',
            'Biella Dintorni',
            'Pianura',
            other,
          ],
          filter: '',
        },
        sezionale: {
          trad: 'Tipologia',
          items: ['', 'Documentaristica'],
          filter: '',
        },
        club: {
          trad: 'Fotoclub',
          items: ['', 'Fotoart Cossato', 'Fotoclub Biella', 'Gruppo Riflessi', 'Obiettivo Sabato', other],
          filter: '',
        },
        elemImg: {
          trad: 'Elementi contenuti',
          items: [
            'Alba',
            'Alta Valle',
            'Animali',
            'Architettura',
            'Architettura Industriale',
            'Arcobaleno',
            'Automobilismo / Motociclismo',
            'Centro storico',
            'Cielo',
            'Collina',
            "Corso d'acqua",
            'Creatività',
            'Documentaristica',
            'Evento',
            'Funivia / Cestovia',
            'Lago',
            'Lama',
            'Modernità',
            'Montagna',
            'Monumento',
            'Neve',
            'Notte',
            'Panorama',
            'Particolare',
            'Piante',
            'Risaia',
            'Sacro',
            'Sentiero',
            'Smart Working',
            'Tradizione',
            'Tramonto',
            'Veicoli Storici',
          ],
          filter: [],
        },
        luogoCaratteristico: {
          trad: 'Luogo Caratteristico',
          items: [
            '',
            'Bielmonte',
            'Castello di Rosazza',
            "Città dell'Arte",
            'Lago di Viverone',
            'Monastero di Bose',
            'Monte Mucrone',
            'Parco della Burcina',
            'Oasi Zegna',
            'Piazzo',
            'Ricetto di Candelo',
            'Santuario di Oropa',
            'Santuario di Graglia',
            'Torrente Cervo',
            'Torrente Elvo',
            'Torrente Gorgomoro',
            'Torrente Sessera',
            other,
          ],
          filter: '',
        },
        layout: {
          trad: 'Orientamento',
          items: ['', 'Orizzontale', 'Verticale'],
          filter: '',
        },
        panel: [],
      };
    },
    watch: {
      panel: function () {
        let data = this.$data;
        let cnt = 0;
        let idx = 1;
        if (!this.panel.includes(idx)) {
          // check if panel is closed
          Object.keys(data).forEach((k) => {
            if (typeof data[k] !== 'undefined') {
              let f = data[k].filter;
              if (typeof f === 'string' && !['comuni', 'licenza', 'luogoCaratteristico', 'zonaBiellese'].includes(k) && f.length > 0) {
                cnt++;
              }
              let interval = data[k].interval;
              let values = data[k].values;
              if (typeof interval !== 'undefined' && typeof values !== 'undefined') {
                if (values[0] > interval[0] || values[1] < interval[1]) {
                  cnt++;
                }
              }
            }
          });

          if (this.dates.length === 2 || this.elemImg.filter.length > 0) {
            cnt++;
          }
          this.showActiveFiltersBadge[idx] = cnt > 0;
        } else {
          this.showActiveFiltersBadge[idx] = false;
        }
        cnt = 0;
        idx = 0;
        if (!this.panel.includes(idx)) {
          // check if panel is closed
          Object.keys(data).forEach((k) => {
            if (typeof data[k] !== 'undefined') {
              let f = data[k].filter;
              if (typeof f === 'string' && ['comuni', 'licenza', 'luogoCaratteristico', 'zonaBiellese'].includes(k) && f.length > 0) {
                cnt++;
              }
            }
          });

          this.showActiveFiltersBadge[idx] = cnt > 0;
        } else {
          this.showActiveFiltersBadge[idx] = false;
        }
      },
      ordMode: function () {
        this.filteredRows = this.sort(this.filteredRows);
      },
      'elemImg.filter': function () {
        this.filter();
      },
      'tecnica.filter': function () {
        this.filter();
      },
      'contesto.filter': function () {
        this.filter();
      },
      'creativita.filter': function () {
        this.filter();
      },
      'pubbl.filter': function () {
        this.filter();
      },
      'pPubblico.filter': function () {
        this.filter();
      },
      'pCritica.filter': function () {
        this.filter();
      },
      'persone.filter': function () {
        this.filter();
      },
      'pUsabilita.filter': function () {
        this.filter();
      },
      'licenza.filter': function () {
        this.filter();
      },
      'club.filter': function () {
        this.filter();
      },
      'sezionale.filter': function () {
        this.filter();
      },
      'comuni.filter': function () {
        this.filter();
      },
      'rating.values': function () {
        this.filter();
      },
      'mp.values': function () {
        this.filter();
      },
      'w.values': function () {
        this.filter();
      },
      'h.values': function () {
        this.filter();
      },
      'size.values': function () {
        this.filter();
      },
      'dpi.values': function () {
        this.filter();
      },
      'fotografo.filter': function () {
        this.filter();
      },
      'zonaBiellese.filter': function () {
        this.filter();
      },
      'layout.filter': function () {
        this.filter();
      },
      'luogoCaratteristico.filter': function () {
        this.filter();
      },
      ordCriteria: function () {
        this.filteredRows = this.sort(this.filteredRows);
        this.ordMode = false;
      },
      dates: function () {
        this.filter();
      },
    },
    computed: {
      getOtherPlaceholder() {
        return 'Altro..';
      },
      getOrdMode() {
        return this.ordMode ? 'decrescente' : 'crescente';
      },
    },
    methods: {
      showPanelsByScreenSize() {
        // this.pnael contains the indicies of the open panels
        if (this.$vuetify.breakpoint.width < 620) {
          this.panel = []; // all panels collapsed
        } else {
          this.panel = [0, 1]; // all panels expanded
        }
      },

      async openDetails(rowId) {
        const item = this.rows.filter((row) => row.id === rowId)[0];
        const resp = await axios.post('https://g3vssvl76gmapbt4bwj4s2uapa0hesfh.lambda-url.eu-west-1.on.aws/', item);

        var tab = window.open('_blank');
        tab.document.write(resp.data);
        tab.document.close();
      },
      checker(arr, target) {
        return target.map((i) => i.toLowerCase()).every((v) => arr.map((i) => i.toLowerCase()).includes(v));
      },
      getOrdOffset() {
        return this.ordMode ? -1 : 1;
      },
      removeFilter() {
        this.ordMode = true;
        this.licenza.filter = '';
        this.zonaBiellese.filter = '';
        this.comuni.filter = '';
        this.luogoCaratteristico.filter = '';
        this.fotografo.filter = '';
        this.dates = [];
        this.club.filter = '';
        this.sezionale.filter = '';
        this.pubbl.filter = '';
        this.elemImg.filter = '';
        this.elemImg.filter = [];
        this.layout.filter = '';
        this.contesto.filter = '';
        this.tecnica.filter = '';
        this.creativita.filter = '';
        this.pPubblico.filter = '';
        this.pCritica.filter = '';
        this.pUsabilita.filter = '';
        this.persone.filter = '';
        this.h.values = [0, this.round(this.rows, 'h', 100)];
        this.mp.values = [0, this.round(this.rows, 'mp', 10)];
        this.w.values = [0, this.round(this.rows, 'w', 100)];
        this.size.values = [0, this.round(this.rows, 'size', 1)];
        this.dpi.values = [0, this.round(this.rows, 'dpi', 10)];
        this.rating.values = [0, 100];
      },
      sort(rows) {
        let res = [];
        switch (this.ordCriteria) {
          case 'Titolo':
            res = [...rows].sort((a, b) => (a.titolo.toLowerCase() > b.titolo.toLowerCase() ? this.getOrdOffset() : -1 * this.getOrdOffset()));
            break;
          case 'Rating':
            res = [...rows].sort((a, b) => (a.rating > b.rating ? this.getOrdOffset() : -1 * this.getOrdOffset()));
            break;
          case 'Autore':
            res = [...rows].sort((a, b) => (a.cognomeNome.toLowerCase() > b.cognomeNome.toLowerCase() ? this.getOrdOffset() : -1 * this.getOrdOffset()));
            break;
          case 'Data upload':
            res = [...rows].sort((a, b) => (a.dUpload > b.dUpload ? this.getOrdOffset() : -1 * this.getOrdOffset()));
            break;
          case 'Casuale':
            res = this.shuffle(rows);
            break;
        }
        return res;
      },
      shuffle(array) {
        let currentIndex = array.length,
          randomIndex;

        while (currentIndex != 0) {
          randomIndex = Math.floor(Math.random() * currentIndex);
          currentIndex--;

          [array[currentIndex], array[randomIndex]] = [array[randomIndex], array[currentIndex]];
        }
        return array;
      },
      filter() {
        let lic = this.licenza.filter;
        this.filteredRows = this.rows.filter((i) => (lic.length === 0 ? true : i.licenza.toLowerCase() === lic.toLowerCase()));
        let zona = this.zonaBiellese.filter;
        this.filteredRows = this.filteredRows.filter((i) =>
          zona.length === 0 ? true : zona === this.otherPlaceholder ? !this.zonaBiellese.items.includes(i.zona) : i.zona.toLowerCase() === zona.toLowerCase()
        );
        let layout = this.layout.filter;
        this.filteredRows = this.filteredRows.filter((i) => (layout.length === 0 ? true : i.layout.toLowerCase() === layout.toLowerCase()));
        let sezionale = this.sezionale.filter;
        this.filteredRows = this.filteredRows.filter((i) => (sezionale.length === 0 ? true : i.sezionale.toLowerCase() === sezionale.toLowerCase()));
        let pubbl = this.pubbl.filter;
        this.filteredRows = this.filteredRows.filter((i) => (pubbl.length === 0 ? true : pubbl === '-' ? i.pubbl.length === 0 : i.pubbl.includes(pubbl)));
        let luogo = this.luogoCaratteristico.filter;
        this.filteredRows = this.filteredRows.filter((i) =>
          luogo.length === 0
            ? true
            : luogo === this.otherPlaceholder
            ? !this.luogoCaratteristico.items.includes(i.luogo)
            : i.luogo.toLowerCase() === luogo.toLowerCase()
        );
        let comune = this.comuni.filter;
        this.filteredRows = this.filteredRows.filter((i) =>
          comune.length === 0
            ? true
            : comune === this.otherPlaceholder
            ? !this.comuni.items.includes(i.comune)
            : i.comune.toLowerCase() === comune.toLowerCase()
        );
        if (this.dates.length === 2) {
          this.filteredRows = this.filteredRows.filter((i) => dayjs(i.dUpload.split('T')[0]).isBetween(dayjs(this.dates[0]), dayjs(this.dates[1])));
        }

        let club = this.club.filter;
        this.filteredRows = this.filteredRows.filter((i) =>
          club.length === 0
            ? true
            : club === this.otherPlaceholder
            ? i.club.length === 0 || !this.club.items.includes(i.club)
            : i.club.toLowerCase() === club.toLowerCase()
        );

        let fotografo = this.fotografo.filter;
        this.filteredRows = this.filteredRows.filter((i) =>
          fotografo.length === 0 ? true : fotografo === 'Anonimo' ? i.cognomeNome.length === 0 : i.cognomeNome.toLowerCase() === fotografo.toLowerCase()
        );
        let elemImg = this.elemImg.filter;
        this.filteredRows = this.filteredRows.filter((i) => (elemImg.length === 0 ? true : this.checker(i.elemImg, elemImg)));
        this.filteredRows = this.filterNumber(this.contesto, 'contestualita');
        this.filteredRows = this.filterNumber(this.tecnica, 'tecnica');
        this.filteredRows = this.filterNumber(this.creativita, 'creativita');
        this.filteredRows = this.filterYesNo(this.persone, 'persone');
        this.filteredRows = this.filterYesNo(this.pUsabilita, 'bUsabilita');
        this.filteredRows = this.filterYesNo(this.pPubblico, 'bPubblico');
        this.filteredRows = this.filterYesNo(this.pCritica, 'bCritica');

        this.filteredRows = this.filterRange(this.rating, 'rating', this.rating.interval[1]);
        this.filteredRows = this.filterRange(this.w, 'w', this.w.interval[1]);
        this.filteredRows = this.filterRange(this.h, 'h', this.h.interval[1]);
        this.filteredRows = this.filterRange(this.size, 'size', this.size.interval[1]);
        this.filteredRows = this.filterRange(this.mp, 'mp', this.mp.interval[1]);
        this.filteredRows = this.filterRange(this.dpi, 'dpi', this.dpi.interval[1]);

        this.filteredRows = this.sort(this.filteredRows);
      },
      filterYesNo(item, key) {
        let value = item.filter;
        return this.filteredRows.filter((i) => (value.length === 0 ? true : (i[key] === true && value === 'sì') || (i[key] === false && value === 'no')));
      },
      filterNumber(item, key) {
        let value = item.filter;
        return this.filteredRows.filter((i) => (value.length === 0 ? true : parseInt(value) === i[key]));
      },
      filterRange(item, key, max) {
        let values = item.values;
        return this.filteredRows.filter((i) => (values[0] === 0 && values[1] === max ? true : i[key] >= values[0] && i[key] <= values[1]));
      },
      async loadDb() {
        const host = 'foto.agendadigitale.biella.it';
        const response = await axios({
          method: 'get',
          url: `https://${host}/data/prod/db.json`,
        });

        const data = response.data;
        const fmt = 'DD/MM/YYYY HH:mm';
        this.updateDate = dayjs(data.date, fmt).utc(true).local().format(fmt);

        const dataset = data.rows;
        dataset.forEach((i) => (i.cognomeNome = i.cognomeNome.replace(',', '')));
        this.rows = this.sort(dataset);
        this.filteredRows = this.rows;
        this.comuni.items.push(
          ...this.filteredRows
            .map((i) => {
              return i.comune;
            })
            .sort((a, b) => (a.toLowerCase() > b.toLowerCase() ? 1 : -1))
        );
        this.fotografo.items.push(
          ...this.filteredRows
            .map((i) => {
              return i.cognomeNome;
            })
            .sort((a, b) => (a.toLowerCase() > b.toLowerCase() ? 1 : -1))
        );

        let maxMp = this.round(this.rows, 'mp', 10);
        this.mp.values = [0, maxMp];
        this.mp.interval[1] = maxMp;

        let maxW = this.round(this.rows, 'w', 100);
        this.w.values = [0, maxW];
        this.w.interval[1] = maxW;

        let maxH = this.round(this.rows, 'h', 100);
        this.h.values = [0, maxH];
        this.h.interval[1] = maxH;

        let maxSize = this.round(this.rows, 'size', 1);
        this.size.values = [0, maxSize];
        this.size.interval[1] = maxSize;

        let maxDpi = this.round(this.rows, 'dpi', 10);
        this.dpi.values = [0, maxDpi];
        this.dpi.interval[1] = maxDpi;
      },

      round(val, key, unit) {
        let res = val.reduce((a, b) => (a[key] > b[key] ? a : b))[key];
        let maxRes = Math.ceil(res / unit) * unit;
        return maxRes;
      },
    },

    mounted() {
      this.loadDb();

      this.showPanelsByScreenSize();

      window.addEventListener('resize', this.showPanelsByScreenSize);
    },
  };
</script>
